import React, {Fragment, Component} from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import styled from 'styled-components';

import { theme, ShowLoader, MainHeader, MainFooter } from "../../components";

import { saveLogin } from "../../redux/actions/loginActions";
import { fetchUser } from "../../redux/actions/userActions";

import {
  Grommet,
  Box,
  Header,
  Sidebar,
  Footer,
  Heading,
  Paragraph,
  Text,
  Anchor, 
  Button, 
  CheckBox,
  Form,
  FormField,
  TextInput,
  RadioButtonGroup,
  RangeInput,
  Select,
  TextArea,
  Collapsible,
  Nav,
  Carousel,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Image,
  Icons,
  Grid,
  Tabs,
  Tab,
  DataTable,
  Avatar,
  Layer,
  Stack,
  Drop,
  DropButton,
  ResponsiveContext, 
} from 'grommet';
import { Menu, FormClose, Notification, User, Cart, Mail, Contact, StatusGoodSmall, FormSearch, FormAdd, FormSubtract, Trash, Shop, FormView, FormViewHide } from 'grommet-icons';

import { Config } from '../../Config';
import { apiconn } from '../../apiconn'; //axios connectors are here

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var checkout = "no";

class Login extends Component {
  constructor(props) {
    super(props);
    this.headerRef = React.createRef();
    
    if(this.props.login.id_user > 0)
      this.props.history.replace('/my-account');
    
    let lang = "id";
    if(this.props.lang !== undefined && this.props.lang.lang !== undefined && this.props.lang.lang == "id" || this.props.lang.lang == "en"){
      lang = this.props.lang.lang;
    }
    
    this.state = {
      lang: lang,
      username: "",
      password: "",
      showpassword: "password",
    }
    
    let querystring = new URLSearchParams(this.props.location.search);
    if(querystring.get("checkout") !== null){
      if(querystring.get("checkout").length > 0)
        checkout = querystring.get("checkout");
    }
  }
  
  toastContainer(){
    return (
      <ToastContainer
      position="top-center"
      autoClose={3000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      />
    )
  }
  
  componentDidMount(){
      
  }
  
  
  doLogin = () => {
    this.setState({isLoading: true});
    
    setTimeout(() => {
      if(this.state.username.toLowerCase() == "upspace" && this.state.password == "ottooana"){
        this.props.history.push({
          pathname: '/signup',
          state: { valid: "valid" }
        })
      } else {
        toast.error("Invalid Username & Password");
        this.setState({isLoading: false});
      }
    }, 500);
  }
  
render(){
    return (
      <Grommet theme={theme} full>
        <ResponsiveContext.Consumer>
            {size => (
              <Box className="main-wrapper" fill={true} flex="{true}">
              { this.toastContainer() }
              
              {this.state.isLoading && <ShowLoader /> }
              
              <Box className="page-stack login" background="url('bg-login.jpg')" flex="grow" fill="horizontal">

                <MainHeader ref={this.headerRef} history={this.props.history} size={size} page="login" />

                <Box justify="center" align="center" flex="grow">
                  <Box className="login-form forms wrapper form-style" flex={false}>
                    <Box align="center" margin={{bottom: "30px"}}>
                      <Heading level="2">Login</Heading>
                    </Box>
                    {checkout == "yes" && 
                      <Box className="signup-link" direction={size !== 'small' ? "row" : "column"} align="center" justify="center" gap="small" margin={{bottom:"15px"}}>
                        <Text color="red">Please login or <Anchor href={"/signup" + (checkout == "yes" ? "?checkout=yes" : "")}>sign up</Anchor> to continue the checkout process</Text>
                      </Box>
                    }
                    <Form>
                      <FormField>
                        <Text className="form-style-label">Username</Text>
                        <TextInput placeholder="Enter your username"  value={this.state.username} onChange={(e) => { this.setState({username: e.target.value}); }} />
                      </FormField>
                      <Box margin={{bottom:"10px"}}>
                        <Text className="form-style-label">Password</Text>
                        <Box direction="row">
                          <TextInput placeholder="Enter your password" type={this.state.showpassword} reverse={true} align="center" value={this.state.password} onChange={(e) => { this.setState({password: e.target.value}); }} />
                        </Box>
                      </Box>
                      
                      <Button primary className="button" margin={{top: "small"}} label={this.state.lang == "en" ? "Sign In" : "Masuk"} onClick={() => this.doLogin()} fill="horizontal" />
                    </Form>
                    
                  </Box>
                </Box>
              </Box>

              <MainFooter size={size} />
              
            </Box>
            )}
          </ResponsiveContext.Consumer>
      </Grommet>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    login: state.loginData,
    lang: state.langData,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveLogin: id_user => {
      dispatch(saveLogin(id_user));
    },
    fetchUser: userdata => {
      dispatch(fetchUser(userdata));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
